import { Ref } from "vue";
import { Facet, FacetSelected } from "@/shared/facets/facets.model.ts";
import { SortEntry } from "@/shared/components/sort-dropdown/sort-dropdown.model.ts";
import { ContentGroupingCriteria } from "../services/graphql/generated/consumer-graph-types";

export enum FieldDefinitionTypes {
    date = "date",
    dateTime = "dateTime",
    dateTimeRange = "dateTimeRange",
    enum = "enum",
    keyword = "keyword",
    number = "number",
    numberRange = "numberRange",
    taxonomy = "taxonomy",
    text = "text",
    boolean = "boolean",
}

export enum FullTextSearchType {
    bestFields = "best_fields",
    mostFields = "most_fields",
    phrase = "phrase",
    prefix = "prefix",
}

export interface SearchContext {
    product?: string;
    asset?: string;
    text?: string; //TODO remove text property
    article?: string;
    mechanicPath?: string;
    mechanic?: string;
}

export interface SearchField {
    referencedId: string;
    fieldType: FieldDefinitionTypes;
    boost?: number | null;
}

export interface SearchParams {
    selected?: Ref<FacetSelected[]>;
    searchContext?: Ref<SearchContext>;
    searchPhrase?: Ref<string>;
    sort?: Ref<SortEntry | undefined>;
    count?: number;
    showFirstRelevantPropertyItemOnly?: boolean;
}

export interface SearchFilteredResultsParams extends SearchParams {
    facet: Ref<Facet | undefined>;
    groupingCriteria?: Ref<ContentGroupingCriteria | null | undefined>;
}

export interface Total {
    count: number;
    countRelation?: "eq" | "gte" | "lte";
}
